import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5a9afcca&scoped=true"
import script from "./card.vue?vue&type=script&setup=true&lang=js"
export * from "./card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=5a9afcca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9afcca",
  null
  
)

export default component.exports